import { Schema } from "@effect/schema";
import { ProtocolKey } from "../protocol";
import { DisplayMarket } from "./display-market";
import { Usd } from "../usd";
import { Percent } from "../percent";

export type MarketsByProtocol = typeof MarketsByProtocol.Type;
export type MarketsByProtocolEncoded = typeof MarketsByProtocol.Encoded;

export const MarketsByProtocol = Schema.Array(
  Schema.Struct({
    protocolKey: ProtocolKey,
    markets: Schema.Array(DisplayMarket),
    tvlUsd: Usd,
  })
).annotations({ identifier: "MarketsByProtocol" });

export type MarketsData = typeof MarketsData.Type;
export type MarketsDataEncoded = typeof MarketsData.Encoded;

export const MarketsData = Schema.Struct({
  marketsByProtocol: MarketsByProtocol,
  revenueApr: Percent,
}).annotations({ identifier: "MarketsData" });
